import { render, staticRenderFns } from "./statistical-analysis-external-views-incidents-statistics.vue?vue&type=template&id=1577166a&scoped=true&"
import script from "./statistical-analysis-external-views-incidents-statistics.ts?vue&type=script&lang=ts&"
export * from "./statistical-analysis-external-views-incidents-statistics.ts?vue&type=script&lang=ts&"
import style0 from "./statistical-analysis-external-views-incidents-statistics.scss?vue&type=style&index=0&id=1577166a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1577166a",
  null
  
)

export default component.exports